import { Search } from '@tmh-website/services/search.service';
import { FormikHelpers } from 'formik';
import get from 'lodash/get';
import isFinite from 'lodash/isFinite';
import { ReactElement } from 'react';
import { FormElementThemeColor } from './FormElements.theme';

export interface SelectOption<T = string> {
  label: T;
  value: string | number;
  disabled?: boolean;
}

export interface SelectOptionWithIcon extends SelectOption {
  icon?: ReactElement | string;
}

export type SelectSearch = Search | false | ((options: SelectOption[], searchFilter: string) => SelectOption[]);

export interface FormElementCommonProps {
  label?: string;
  name: string;
  themeColor: FormElementThemeColor;
  required?: boolean;
  disabled?: boolean;
}

export function validateNumberInput(
  values: any,
  name: string,
  setFieldValue: FormikHelpers<any>['setFieldValue'],
  min?: number,
  max?: number
) {
  const currentValue = parseFloat(get(values, name));
  if (min !== undefined && currentValue < min) {
    setFieldValue(name, min);
  }
  if (max !== undefined && currentValue > max) {
    setFieldValue(name, max);
  }
}

export function changeNumberValue(
  modifier: number,
  step: number,
  values: any,
  name: string,
  setFieldValue: FormikHelpers<any>['setFieldValue'],
  setFieldTouched: FormikHelpers<any>['setFieldTouched'],
  min?: number,
  max?: number
) {
  const currentValue = parseFloat(get(values, name));

  if (isFinite(currentValue)) {
    // Fix rounding errors
    let newValue = Math.round((currentValue + step * modifier) * 10000) / 10000;
    if (min !== undefined) {
      newValue = Math.max(min, newValue);
    }
    if (max !== undefined) {
      newValue = Math.min(max, newValue);
    }
    setFieldValue(name, newValue);
  } else {
    // Not a number so we need to fix this value
    setFieldValue(name, min ?? 0);
  }

  setFieldTouched(name, true);
}
